import { FC } from "react";

import { twMerge } from "tailwind-merge";

import ConTeLoadingGif from "../../assets/gif/conte-loading.gif";

const LoaderOverlay: FC<any> = ({ isSuspend = false }) => {
  return (
    <div
      data-testid="loader-overlay"
      className={twMerge(
        "w-full h-full fixed top-0 flex justify-center items-center z-[1000] bg-[#09458580]",
        isSuspend ? "" : "md:pl-28",
      )}
    >
      <div className="flex flex-col gap-5">
        <img
          src={ConTeLoadingGif}
          className="rounded-2xl w-20 mx-auto"
          alt="Immagine di caricamento"
        />
        <p className="text-white font-bold">Caricamento in corso...</p>
      </div>
    </div>
  );
};

export default LoaderOverlay;
